﻿import React from 'react';

//lib
import { v4 as uuidv4 } from 'uuid';
import { motion, AnimatePresence } from "framer-motion";


// utils
import IconHelper from '@bazooka_se/lf-icons';
import RawHtml from '../../../../../UI/RawHtml';

const PossessionsTableContentChartMobile = ({
    levels,
    description,
    title,
    isExpanded,
    setIsExpanded,
    index
}) => {

    const isOpen = index === isExpanded;

    const specs = (level) => {

        const included = level.included === true;
        const text = level.text;

        if (included && text) {
            return <div key={uuidv4()}
                className="possessions__table__mobile__body__icon possessions__table__mobile__body__icon--text">
                {text}
            </div>

        } else if (included) {
            return <div key={uuidv4()}
                className="possessions__table__mobile__body__icon possessions__table__mobile__body__icon--included" dangerouslySetInnerHTML={{ __html: IconHelper('check').outerHTML }}>
            </div>
        } 
        else {
            return <div key={uuidv4()}
                className="possessions__table__mobile__body__icon possessions__table__mobile__body__icon--omitted" dangerouslySetInnerHTML={{ __html: IconHelper('close').outerHTML }}>
            </div>
        }
    }

    return (    
        <div className={`possessions__table__mobile__body ${isOpen ? "possessions__table__mobile__body--open" : ""}`}>
            <motion.div
                className="possessions__table__mobile__body__heading"
                onClick={() => setIsExpanded(isOpen ? false : index)}>
                {title}

                {description !== null &&
                    <button
                        dangerouslySetInnerHTML={{ __html: IconHelper('chev-down').outerHTML }}
                    className="possessions__table__mobile__body__heading__icon">
                    </button>
                }

                    <AnimatePresence
                        initial={false}>
                        {description && description.length > 0 && isOpen && (
                            <motion.div
                                className="possessions__table__mobile__body__foldout"
                                key="content"
                                initial="collapsed"
                                animate="open"
                                exit="collapsed"
                                variants={{
                                    open: { opacity: 1, height: "auto" },
                                    collapsed: { opacity: 0, height: 0 }
                                }}
                                transition={{ duration: 0.4, ease: [0.04, 0.62, 0.23, 0.98] }}>

                                <RawHtml>{description}</RawHtml>

                            </motion.div>
                        )}
                </AnimatePresence>     
            </motion.div>

            <div className="possessions__table__mobile__body__levels">
                {levels.map((level, i) => (specs(level, i)))}
            </div>


      </div>
   )
};

export default PossessionsTableContentChartMobile;

